<template>
  <div class="componentWrapper services" @click="listenOut" :class="{ true: isShowing }">
    {{findLogoColour}}

    <div id="services" class="grid grid__item_span-12">
      <!-- LEFT COLUMN -->
      <div id="left" class="grid__item_span-12 m0">

        <!-- INTRODUCTION -->
        <div id="intro" class="grid__item_span-6 m0 p0">
          <h2 class="">Let's work together</h2>
          <p id="intropara" class="grid__item_span-10 m0 p0">{{intro}}</p>
          <p class="grid__item_span-10 m0 p0">{{extraintro}}</p>
        </div>

        <!-- FLOCK LIST -->
        <div id="flockList" class="grid grid__item_span-6 m0 p0">

          <!-- The list wrapper -->
            <div class="departmentWrap grid grid__item_span-10 m0 p0">
            <div class="names grid grid__item_span-6 m0 p0">
              <p v-for="member in list" class="m0 p0">

                <router-link :to="{ name: member.slug.name, params: { slug: member.slug.url, id:member.slug.id }}">
                  <span class="flocker" :photo-attr="member.image.url" @click="show = !show" v-on:mouseover="hover(member.name)" v-on:mouseout="hoverOff()">
                    <span class="line"><div class="inner"></div></span>
                    <span v-html="member.name"></span>
                    <div v-if="mobileClass">
                      <div id="previewImage" class="grid grid__item_span-6 m0" flock="" style=""></div>
                      <div class="item">
                        <img :src="member.image.url" alt="member.image.alt" title="member.image.title"/>
                        <p>{{member.services}}</p>
                        <a href="">Learn more</a>
                      </div>
                    </div>
                  </span>
                </router-link>
              </p>
              <p class="m0 p0">
                <a href="/kia-kaha-nz">
                  <span>COVID-19 Packages</span>
                </a>
              </p>
            </div>

        </div>
      </div>

      <!-- RIGHT COLUMN / INSTAGRAM FEED -->
      <div id="instagramFeed" class="grid grid__item_span-6 m0" v-if="!mobileClass">
        <img :src="teamImage.url" :alt="teamImage.alt" :title="teamImage.title" />
      </div>

      <!-- FLOCK MEMBER PHOTO // this appears on hover -->
      <div id="previewImages" v-if="!mobileClass">
        <div id="previewImage" class="grid grid__item_span-6 m0" flock="" style=""></div>
        <div class="item" v-for="member in list" :name-attr="member.name">
          <div :style="'background: url(' + member.image.url + ') no-repeat 0 0 / cover;'" ></div>
          <p>{{member.services}}</p>
        </div>
      </div>

      <div id="scrollDown" v-on:click="scrollTo('casestudiesPreview')">
        <img src="../../static/white-arrow-down.svg" alt="" title="" /><p>Want to see it in practice?</p>
      </div>

    </div>



    <!-- CASE STUDY LINKS -->
    <div id="casestudiesPreview" class="grid grid__item_span-12 p0">
      <p>Check out the results we’ve helped our clients achieve.</p>
    </div>

  </div>

  <!-- FOUR CASE STUDIES -->
  <div id="servicesCases" class="grid grid__item_span-12 p0 m0">
    <div v-for="item in ourwork" class="item-1 grid grid__item_span-6 p0 m0">
      <router-link :to="{ name: item.slug.name, params: { slug: item.slug.url, id: item.slug.id }}" @click="setImage(index)" class="txtWhite">
        <div class="image" :style="'background-image: url(' + item.featuredImage + ')'"></div>
        <!-- <img :src="slide.headerImageURL"/> -->
        <div class="overlay" data-swiper-parallax="-700">
          <p class="txtWhite uppercase">
            <span>{{item.client}}.</span>
          </p>
          <h2 class="txtWhite">{{item.title}}</h2>
          <p class="tiny">View case study</p>
        </div>
      </router-link>
    </div>
  </div>


  <!-- FOOTER SPACE -->
  <div id="projHeader" class="projheader grid grid__item_span-12 p0 m0">
    <div  id="text" class="overlay">
      <h2 class="txtWhite">Can we help your business do clever things?</h2>
      <p class="txtWhite" @click="openContact2"><span>Let's chat</span></p>
    </div>
  </div>




</div>
</template>

<script>

import VueInstagram from 'vue-instagram'
import Profile from '../components/profile.vue'
import singleFlock from '../assets/js/flockers.js'
import menuTransitions from '../assets/js/menu.js'
import animateScrollTo from 'animated-scroll-to'
import Axios from 'axios'

export default {
  name: 'Services',
  data () {
    return {
      logoColour: 'black',
      isShowing: false,
      show: false,
      metaTitle: '',
      metaDescription: '',
      mobileClass: '',
      heading: '',
      intro: '',
      extraintro: '',
      teamImage: '',
      work: '',
      ourwork: [],
      list: [],
      departments: [],
      departGroups: []
    }
  },
  metaInfo () {
    return {
      title: 'Services',
      meta: [
        { vmid: 'description', name: 'description', content: 'Our team can help you with everything: design, branding, video, animation, web development, SEO, digital marketing, strategy, copywriting, social media & more.' }
      ]
    }
  },
  methods: {
    mobileDetect () {
      var browserSize = window.innerWidth || document.body.clientWidth
      console.log(browserSize)
      var deviceMaxSize = 1024
      if (browserSize < deviceMaxSize) {
        this.mobileClass = 'deviceActive'
      }
    },
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/230').then(response => {
        this.metaTitle = response.data.acf.meta_title
        this.metaDescription = response.data.acf.meta_description
        this.logoColour = response.data.acf.bsd_logo_colour
        this.heading = response.data.title.rendered
        this.intro = response.data.acf.page_intro
        this.extraintro = response.data.acf.page_content
        this.teamImage = response.data.acf.page_image
        this.work = response.data.acf.highlight_work

        var workcases = this.work
        for (var s = 0; s < workcases.length; s++) {
          var caseID = workcases[s].ID
          // console.log(caseID)
          Axios.get(this.$root.$data.site + '/wp-json/wp/v2/ourwork/' + caseID).then(response => {
            // console.log(response)
            var ourwork = {
              title: response.data.acf.project_title,
              client: response.data.acf.client_name,
              cta: response.data.acf.project_cta,
              type: response.data.acf.project_type,
              featuredImage: response.data.acf.featured_image.url,
              id: response.data.id,
              slug: {
                name: 'Project',
                url: response.data.slug,
                id: response.data.id
              }
            }
            // console.log(ourwork)
            this.ourwork.push(ourwork)
          }).catch(function (error) {
            console.log(error)
          })
        }
      }).catch(function (error) {
        console.log(error)
      })
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/services/?per_page=100').then(response => {
        var list = response.data.map(obj => {
          return {
            name: obj.title.rendered,
            description: obj.acf.service_description,
            services: obj.acf.specific_services,
            image: obj.acf.service_image,
            imageSize: obj.acf.service_image_size,
            imageSize_mobile: obj.acf.service_image_mobile_size,
            team: obj.acf.bsd_department_services,
            ID: obj.acf.id,
            slug: {
              name: 'Service',
              url: obj.slug,
              id: obj.id
            }
          }
        })
        // console.log(list)
        list.forEach(el => {
          this.list.push(el)
        })

        var departments = response.data.map(obj => {
          return {
            depart: obj.acf.bsd_department_services
          }
        })
        departments.forEach(el => {
          this.departments.push(el)
        })
      }).catch(function (error) {
        console.log(error)
      })
    },
    hover: function (name, done) {
      singleFlock.nameHover(name, done)
    },
    hoverOff: function (done) {
      singleFlock.nameRemoveHover(done)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    closeMenuDown () { // after timeout this closes menu
      // console.log('lock down')
      setTimeout(function () {
        // menuTransitions.hideHeader()
        var appWrapper = document.body
        var wrap = document.getElementById('wrap')
        var header = document.getElementById('header')
        var moveheader = document.getElementById('movingHeader')
        var menuBtn = document.getElementById('menuBtn')
        header.classList.remove('true')
        moveheader.classList.remove('true')
        menuBtn.classList.remove('true')
        appWrapper.removeAttribute('style')
        appWrapper.style.overflowY = 'scroll'
        wrap.classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }, 2500)
    },
    isMenuOpen () { // on page load if menu is open it will close
      var pageHeader = document.getElementById('header')
      if (pageHeader.classList.contains('true')) {
        // console.log('yay')
        this.isShowing = true
      } else {
        document.getElementById('header').classList.remove('true')
        document.getElementById('movingHeader').classList.remove('true')
        document.getElementById('menuBtn').classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }
    },
    scrollTo (destination) { // scroll to a div position
      // console.log(destination)
      var destinationWrap = document.getElementById(destination)
      const options = {
        speed: 1000
      }
      animateScrollTo(destinationWrap, options)
    },
    openContact2 () {
      // console.log('step 1')
      this.isShowing = true
      this.$bus.$emit('openContact2', {isShowing: true})
    }
  },
  mounted () {
    this.mobileDetect()
    this.isMenuOpen()
    this.closeMenuDown()

    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    setTimeout(function () {
      document.getElementById('intro').classList.add('fadeMeIn')
    }, 600)
    setTimeout(function () {
      document.getElementById('instagramFeed').classList.add('fadeMeIn')
    }, 550)
    setTimeout(function () {
      document.getElementById('flockList').classList.add('fadeMeIn')
    }, 750)
    setTimeout(function () {
      document.getElementById('scrollDown').classList.add('fadeMeIn')
    }, 900)
  },
  computed: {
    findLogoColour: function () { // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    },
    filterDepartments: function () {
      for (var i = 0; i < this.departments.length; i++) {
        if (this.departGroups.indexOf(this.departments[i].depart) === -1) {
          this.departGroups.push(this.departments[i].depart)
        }
      }
      return this.departGroups
    }
  },
  created () {
    this.getData()

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://cdn.lightwidget.com/widgets/lightwidget.js')
    document.head.appendChild(recaptchaScript)
  },
  components: {
    VueInstagram,
    Profile
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #previewImage{
    background-repeat: no-repeat;
    background-position:  50% 0;
    background-size: cover;
  }

  .componentWrapper{
    /* padding-top: 13vh;
    padding-left: 2%;
    background: #EFF0F1; */
  }

</style>



// WEBPACK FOOTER //
// src/components/ourservices.vue